export { Main, MainTop, MainTopTitle, MainTopLeft, MainTopRight, MainBody } from './Layout.Main'
export { WhiteBox } from './Layout.Box'
export { ButtonSection, ButtonGroupCustom } from './Layout.ButtonSection'
export { BoxHeader } from './Layout.BoxHeader'



// WEBPACK FOOTER //
// ./src/components/Layout/index.js